import { render, staticRenderFns } from "./icon-component.vue?vue&type=template&id=1f87d1cd&scoped=true&"
import script from "./icon-component.vue?vue&type=script&lang=ts&"
export * from "./icon-component.vue?vue&type=script&lang=ts&"
import style0 from "./icon-component.vue?vue&type=style&index=0&id=1f87d1cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f87d1cd",
  null
  
)

export default component.exports